// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Vdc9","label":"Radio_label__1NU02","checkMark":"Radio_checkMark__W26nI","disabled":"Radio_disabled__CXwIC"};